export const helperNotebookTooltip =
  'This lets you define a notebook that can contain UDFs and helper functions that can be used by the datasource. Helper functions will be automatically added to this notebook when you use helper functions in the Pre-transform, Silver and Gold configuration';

export const generateTemplateNotebook =
  'This generates a blank helper notebook and opens it in a new tab';

export const scheduleAtLeastEveryDs =
  'The datasource will be scheduled to run on this interval. Under certain circumstances it may run more frequently than this';

export const scheduleExactlyAtDs = (
  <>
    The datasource will be scheduled to run according to this cron schedule.
    <br />
    <br />
    See also{' '}
    <a
      href="http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html"
      target="_blank"
      rel="noopener noreferrer"
    >
      the Quartz Cron Syntax
    </a>
  </>
);

export const dsDisabled =
  'A disabled datasource will not be run, but the checkpoints are preserved, so when re-enabled it resumes from where it left off';

export const computeDedicatedTooltipRl =
  'This detection will be executed with dedicated serverless resources';

export const computeAutomaticTooltipRl =
  'This detection execution may be automatically combined with other detections that are processing the same data in order to optimize compute costs';

export const computeGroupTooltipRl =
  'This detection will be executed together with other detections in the same group. Note that changing groups will reset the checkpoints for the detection, causing it to resume processing from the current time';

export const dsUseAutoloader =
  'Use Databricks Autoloader to populate the bronze table';

export const dsSkipBronzeTable =
  'Do not load data into bronze table (select if your tables are populated externally)';

export const schemaHintsTooltip = (
  <>
    Schema hints to pass to Auto Loader
    <br />
    <br />
    see{' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://docs.databricks.com/en/ingestion/cloud-object-storage/auto-loader/schema.html#override-schema-inference-with-schema-hints"
    >
      the Auto Loader docs
    </a>
  </>
);

export const schemaFileTooltip = (
  <>
    Path to a file to read schema definition from and pass to data stream
    reader. File contents need to be valid DDL (schemaHints syntax).
    <br />
    <br />
    see{' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://spark.apache.org/docs/latest/api/python/reference/pyspark.ss/api/pyspark.sql.streaming.DataStreamReader.schema.html"
    >
      the DataStreamReader docs
    </a>
  </>
);

export const joinTypeStatic =
  "A static join is best for data that doesn't change frequently";

export const joinTypeStreamingBronze =
  'A streaming join is best for time-based tables that are being populated in parallel to the bronze table';

export const eventTimeColumnTooltip =
  'The column to use for structured streaming watermarking';

export const delayThresholdTooltip =
  'How late data can be before being excluded by structured streaming';

export const dropDuplicatesTooltip =
  'Rows having identical values for this set of columns as a previous row within the delay threshold will be dropped';

export const tableAliasTooltip =
  'The name by which this table can be referred to in the detection SQL';

export const collidingJsonTooltip =
  'If a field extracted from the json column would have the same name as an existing column, this prefix is prepended on to the new column to disambiguate it';

export const collidingUnreferencedTooltip =
  'If an unreferenced column that would be preserved has the same name as an already existing column in the destination table, this prefix is prepended on to the new column to disambiguate it';

export const fieldsToOmitTooltip =
  'These fields in the JSON object will not be extracted';

export const columnsToOmitTooltip =
  'Prevent these columns in the source table from being preserved, even if they are not explicitly referenced';

export const jsonExtractionTooltip =
  'If you have a column containing a JSON string or a variant, this allows you to automatically extract the fields from that object into strongly typed columns';

export const jsonEmbedTooltip =
  'If yes, the extracted JSON fields will be stored inside a struct column rather than top level columns';

export const unreferencedEmbedTooltip =
  'If yes, the preserved unreferenced columns will be stored inside a new struct column on the result table rather than at the top level';

export const unreferencedFieldsTooltip =
  "If you have columns in the source table that are not explicitly used in the field list (only 'copy from' field types count as an explicit use), this allows you to automatically copy those columns to the destination table. This can be useful to ensure data is not lost if the source table has new fields added to it";

export const addFieldAssertionTooltip =
  'Assertions are a list of SQL expressions that will be evaluated for each row. If one of these expressions does not evaluate to True, an operational alert will be raised with the configured message. This is often used to manage data health, such as asserting that a column is not NULL or that the value falls within a particular range';

export const convertToCustomFunctionTooltip =
  'This will add a new function to the helper notebook (creating one if necessary) that contains logic equivalent to the above configuration for this table. This python code can then be modified as required';

export const fieldSrcCopyTooltip =
  'This transformed field is a direct copy/rename of a field in the source table';

export const fieldSrcAliasTooltip =
  'This transformed field is a copy of an already transformed field in the destination table';

export const fieldSrcExprTooltip =
  "This field's value is obtained from a SQL expression such as: src_col + 2";

export const fieldSrcStringTooltip = "This field's value is a string literal";

export const fieldSrcJoinTooltip =
  'Derive this field from an enrichment join with a CSV or table';

export const functionParametersTooltip =
  'Function parameters are optional. They will be passed to the keyword arguments of your python function and can be useful if you are re-using a function';

export const optDefaultTooltip =
  'Liquid clustering will be configured to optimize data layout based on time and event ID';

export const optCustomTooltip =
  'Customize the columns that will be used for liquid clustering';

export const blankCustomFunctionTooltip =
  'Add a new function to the helper notebook that defines this table';

export const annotationsRlTooltip =
  'Annotations allow you to apply additional tags to your rules for easy searching and organization';

export const severityTooltip =
  'Enter a severity, or a templated expression that resolves to a severity, e.g. {CASE WHEN col THEN "High" ELSE "Medium" END}';

export const rlStreamingTooltip =
  'Configure a rule that processes data as it streams in. This offers the lowest detection latency but has some limitations on the types of aggregation that can be done';

export const rlBatchTooltip =
  'Configure this rule as a scheduled search that runs periodically. Batch input cannot be selected if the rule processing schedule is "continuous"';

export const rlInlineTooltip = 'Configure the detection rule using this UI';

export const rlNotebookTooltip =
  'Configure the detection rule using a custom notebook';

export const observablesTooltip =
  'Entities or assets referenced in an event, such as IP addresses or email addresses, can be configured as Observables in a rule, with an associated impact and confidence. When a rule triggers, the risk (impact * confidence) is added to the total risk score for that kind and value of observable. This allows for risk based alerting and easy identification of problematic entities';

export const observableRelationshipTooltip =
  'If there are multiple of the same kind of entity associated with an event (e.g. source IP address and destination IP address) you can use the relationship to record how the observable relates to an event';

export const collationTooltip =
  'Collation allows for multiple similar notables occurring within a specified period to be combined into a single notable';

export const collateActionTooltip =
  'How to handle notables with identical values for the selected columns. Append will embed all similar notables into one notable. This is unsuitable for high volume rules. Update Stats will increment the numberOfMatchingEvents field in the notable, but not store the duplicate notables. Inhibit will discard duplicate notables entirely. Append and Update Stats will accumulate the risk from observables as if the notables had not been collated. Inhibit will not increment the risk for observables appearing in duplicate notables.';

export const observableValueTooltip =
  'Enter a templated SQL string that show how to extract the observable from the event. (e.g. {ip_address})';

export const observableImpactTooltip =
  'Enter a SQL expression indicating the impact (should evaluate to a number between 0-100) (e.g. src_col * 10)';

export const observableConfidenceTooltip =
  'A SQL expression indicating the confidence (should evaluate to a number between 0-100) (e.g. src_col * 10)';

export const transformFilterTooltip =
  'A where clause right before sql statement';

export const transformSqlTooltip =
  'This is the projection into the output table (a full sql statement using spark.sql), the SQL statement will expect a table/view called "input". default to select * from input.';

export const notebookPathPlaceholder =
  'Enter a path to an existing notebook or click "Generate a template notebook" to generate a notebook';

export const workspaceConfigJiraProjectTooltip =
  'Name of the Jira project in which to create tickets';

export const workspaceConfigJiraIssueTypeTooltip =
  'The type of Jira issue (e.g. Task) that should be created in the project. If in doubt, Task is likely (but not certainly) a safe choice';

export const workspaceConfigJiraServerTooltip =
  'Full URL of the Atlassian instance';

export const workspaceConfigJiraSummaryTooltip =
  'Spark SQL expression used to compute the title of the Jira tickets to be raised. The description of the ticket will contain the JSON-serialized notable or operational alert.';

export const workspaceConfigJiraEmailTooltip =
  'Email of the user who will auth to Jira. The token must be an API token for this user.';

export const workspaceConfigJiraTokenTooltip =
  'The token must be a Jira API token exported from Jira for the given email';

export const workspaceConfigServiceNowUserIDTooltip =
  'The user ID in ServiceNow of the integration user with the "evt_mgmt_integration" role';

export const workspaceConfigServiceNowPasswordTooltip =
  'The password must be a ServiceNow password for the given userID';

export const workspaceConfigServiceNowServerTooltip =
  'Full URL of the ServiceNow instance. For example, "https://my-instance.service-now.com"';

export const workspaceConfigServiceNowSourceExprTooltip =
  'An event string template used to compute the "source" field of the posted event. If this value is not specified, the event will be posted with a "source" of "dasl".';

export const workspaceConfigServiceNowNodeExprTooltip =
  'An event string template used to compute the "node" field of the posted event. This field is generally used to identity the specific host or device that generated the event. If this value is not specified, the event will be posted without a "node" field.';

export const workspaceConfigServiceNowSeverityExprTooltip =
  'An event string template used to compute the severity of the event. This expression should evaluate to an integer value between 0 and 5, where 0=Clear, 1=Critical, 2=Major, 3=Minor, 4=Warning, and 5=Informational. If there is an issue with this expression, the event in ServiceNow, after being processed, will be in the "Error" state.';

export const workspaceConfigServiceNowEventTypeTooltip =
  'The type of the event that will be posted to ServiceNow. If this value is not specified, the event will be posted with the "Security" type, which is compatible with the Security Incident Response plugin.';

export const ruleDetectionSqlStreamingTooltip =
  "This is the SQL query that will yield the rows that are transformed into notable events (one per row). The streaming dataframe is available as 'input'";

export const ruleDetectionSqlBatchTooltip =
  'This is the SQL query that will yield the rows that are transformed into notable events (one per row). It can query from any tables and do any joins and aggregations. Make sure that when run on the schedule you have configured that you will not get duplicate rows returned between subsequent runs.';

export const invalidatePresetCachesTooltip =
  'Invalidates all preset caches. This will cause all presets, including custom presets, to be re-fetched from the server.';

export const bronzeMedallionTooltip = 'This preset ingests data through bronze';

export const silverMedallionTooltip =
  'This preset ingests data through bronze and silver';

export const goldMedallionTooltip =
  'This preset ingests data through bronze, silver and gold';
